import { type AdsAccount } from "../../../zodios/apiDefinitions/api/advertisingAccounts";

/**
 * The entity IDs that back the org's own advertising profiles: for each profile, the entity ID its
 * ads account has in the profile's marketplace. Mirrors `build_recommended_entities` in
 * app-rest-api, which recommends the same advertisers when it creates an instance automatically.
 */
export function getRecommendedEntityIds(profileIds: ReadonlyArray<string>, accounts: ReadonlyArray<AdsAccount>) {
  const recommended = new Set<string>();
  for (const profileId of profileIds) {
    for (const account of accounts) {
      const profile = account.profileIds.find(({ id }) => id === profileId);
      const entity = profile && account.entityIds.find(({ countryCode }) => countryCode === profile.countryCode);
      if (entity) {
        recommended.add(entity.id);
      }
    }
  }
  return recommended;
}
